'use client';
import { LoginPage } from 'app/features/auth/login/LoginPage';
import { Auth0LoginPage } from 'app/features/auth/loginAuth0/Auth0LoginPage';
import useFlag from 'app/hooks/useFlag';

export default function Login() {
  const auth0Enabled = useFlag('enableV2Auth0');
  return auth0Enabled ? <Auth0LoginPage /> : <LoginPage />;
}
